import * as _ from "underscore";
import { ExemptAction } from "../../credo-exemption-context";
var isNewExemptionBasedOnExemptionData = function (exemption, tier) {
    var _recent_not_cancelled_ticket = !_.isUndefined(exemption) && _.find(exemption, function (data) { return ("CANCELLED" !== data.status.toUpperCase() && data.tier == tier); });
    if (_recent_not_cancelled_ticket) {
        return !(_recent_not_cancelled_ticket.status.toUpperCase() in ["OPEN", "EXEMPTED"]);
    }
    return true;
};
var isNewExemptionBasedOnCredoData = function (credoData, service) {
    var _recent_not_cancelled_ticket = !_.isUndefined(credoData) && _.find(credoData, function (data) { return "CANCELLED" !== data.status.toUpperCase(); });
    if (_recent_not_cancelled_ticket) {
        // due to a bug that credo ticket doesn't persist the tier info in jira when its soc2 hence we don't have other choice
        if (_recent_not_cancelled_ticket.soc2 || _recent_not_cancelled_ticket.tier == service.metadata.sla.serviceTier) {
            return false;
        }
    }
    return true;
};
export var CredoExemptionTicketLink = 'https://hello.atlassian.net/browse/';
var CredoExemptionUtils = /** @class */ (function () {
    function CredoExemptionUtils() {
    }
    CredoExemptionUtils.getPossibleAction = function (ticket, currentTier) {
        switch (ticket.status.toUpperCase()) {
            case "EXPIRED":
                return ticket.tier === currentTier ? { name: ExemptAction.EXTEND, label: "Extend", appearance: "primary" } : null;
            case "OPEN":
                return { name: ExemptAction.CANCEL, label: "Cancel", appearance: "warning" };
            default:
                return null;
        }
    };
    CredoExemptionUtils.getStatus = function (status) {
        switch (status.toUpperCase()) {
            case "OPEN":
                return { label: "OPEN", appearance: "new", toolTip: "" };
            case "APPROVED":
                return { label: "APPROVED", appearance: "success", toolTip: "Expiring on" };
            case "EXEMPTED":
                return { label: "EXEMPTED", appearance: "success", toolTip: "Expiring on" };
            case "EXPIRED":
                return { label: "EXPIRED", appearance: "removed", toolTip: "Expired on" };
            case "REJECTED":
                return { label: "REJECTED", appearance: "success", toolTip: "" };
            case "CREDO IN PROGRESS":
                return { label: "CREDO IN PROGRESS", appearance: "success", toolTip: "Expiring on" };
            case "CREDO DONE":
                return { label: "CREDO DONE", appearance: "success", toolTip: "Expired on" };
            default:
                return { label: status, appearance: "default", toolTip: "" };
        }
    };
    CredoExemptionUtils.evaluateExemption = function (credoExemptionFF, servicedne, complianceComplete, credo, credoExemption, service) {
        var _exemptionPendingApproval = false;
        if (servicedne || !credoExemptionFF || !complianceComplete) {
            return { isExempted: false, isNewExemptionEnabled: false, action: null, isHistoryAvailable: false, isExemptionPendingApproval: _exemptionPendingApproval };
        }
        var _action = ExemptAction.DISPLAY;
        var _historyAvailable = !!(credoExemption && credoExemption.length);
        _exemptionPendingApproval = !_.isUndefined(credoExemption) && !!(_.find(credoExemption, function (data) { return ("OPEN" === data.status.toUpperCase() && data.tier == service.metadata.sla.serviceTier); }));
        // Always consider first exemption in the list is the recent one
        var _exempted = _historyAvailable && !_.isUndefined(credoExemption) && !!(_.find(credoExemption, function (data) { return (("EXEMPTED" === data.status.toUpperCase() || "CREDO IN PROGRESS" === data.status.toUpperCase()) && data.tier == service.metadata.sla.serviceTier); }));
        if (_exempted) {
            return { isExempted: _exempted, isNewExemptionEnabled: false, action: _action, isHistoryAvailable: _historyAvailable, isExemptionPendingApproval: _exemptionPendingApproval };
        }
        var _newExemptionEnabled = !_exemptionPendingApproval && (_.isEmpty(credo) || isNewExemptionBasedOnCredoData(credo, service));
        _newExemptionEnabled = _newExemptionEnabled && (_.isEmpty(credoExemption) || isNewExemptionBasedOnExemptionData(credoExemption, service.metadata.sla.serviceTier));
        if (_newExemptionEnabled) {
            _action = ExemptAction.CREATE;
        }
        return { isExempted: _exempted, isNewExemptionEnabled: _newExemptionEnabled, action: _action, isHistoryAvailable: _historyAvailable, isExemptionPendingApproval: _exemptionPendingApproval };
    };
    CredoExemptionUtils.evaluateExemptionBasedOnExistingMetaData = function (credoExemption, existingMetaData, tier) {
        var _exemptionPendingApproval = !_.isUndefined(credoExemption) && !!(_.find(credoExemption, function (data) { return ("OPEN" === data.status.toUpperCase() && data.tier == tier); }));
        var _historyAvailable = !!(credoExemption && credoExemption.length);
        var _exempted = _historyAvailable && !_.isUndefined(credoExemption) && !!(_.find(credoExemption, function (data) { return (("EXEMPTED" === data.status.toUpperCase() || "CREDO IN PROGRESS" === data.status.toUpperCase()) && data.tier == tier); }));
        var _newExemptionEnabled = !existingMetaData.isNewExemptionEnabled && (_.isEmpty(credoExemption) || isNewExemptionBasedOnExemptionData(credoExemption, tier));
        var _action = _newExemptionEnabled ? ExemptAction.CREATE : ExemptAction.DISPLAY;
        return { isExempted: _exempted, isNewExemptionEnabled: _newExemptionEnabled, action: _action, isHistoryAvailable: _historyAvailable, isExemptionPendingApproval: _exemptionPendingApproval };
    };
    return CredoExemptionUtils;
}());
export default CredoExemptionUtils;
